import { CustomTheme } from "./CustomThemeInterface";

export const customValues: CustomTheme = {
    colors: {
        neutrals: {
            neutral600: "#181818",
            neutral500: "#333333",
            neutral400: "#525252",
            neutral300: "#999999",
            neutral200: "#E8E8E8",
            neutral100: "#F8F8F8",
            white: "#FFFFFF",
        },
        primary: {
            blue600: "#1B079C",
            blue500: "#270ADC",
            blue400: "#533CDC",
            blue300: "#887ADE",
            blue200: "#AEA5E4",
            blue100: "#DEDBF0",
            blue75: "#F0F1F9",
        },
        secondary: {
            sky: "#0093E5",
            teal: "#00C7A3",
            softBlue: "#A4D0F9",
        },
        feedback: {
            error: "#DF5031",
            errorBackground: "#FDDBD4",
            warning: "#FFAB00",
            warningBackground: "#FFF1D6",
            success: "#00AF41",
            successBackground: "#E3FCEF",
            health: "rgba(0, 147, 229, 1)",
        },
        dataVisualization: {
            lime: "#CDE838",
            orange: "#FF8A00",
            teal: "#00C7A3",
            sky: "#0093E5",
            violet: "#6161FF",
            plum: "#955196",
            midnight: "#374387",
        },
    },
    focusShadow: "0px 0px 5px #0093E5",
};
